import { ChangeProject, Project } from './../../project.model';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-change-project-dialog',
  templateUrl: './change-project-dialog.component.html',
  styleUrls: ['./change-project-dialog.component.scss']
})
export class ChangeProjectDialogComponent implements OnInit {

  project: Project;
  confirmEnabled = false;

  formGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<ChangeProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpService
  ) {
    this.project = data.project;

    this.formGroup.addControl('name', new FormControl(this.project.name, [Validators.required]));
    this.formGroup.addControl('startDate', new FormControl(this.project.validPeriod.from, []));
    this.formGroup.addControl('endDate', new FormControl(this.project.validPeriod.until, []));
    this.formGroup.addControl('archived', new FormControl(this.project.archived, []));
  }

  ngOnInit(): void {
    this.formGroup.statusChanges.subscribe(() =>
      this.confirmEnabled = this.formGroup.valid
    );
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    const changeProject: ChangeProject = {
      projectId: this.project.id,
      name: this.formGroup.controls.name.value,
      archived: this.formGroup.controls.archived.value,
      startDate: this.formGroup.controls.startDate.value,
      endDate: this.formGroup.controls.endDate.value
    };

    this.http.postWithContext<number>(environment.erpProjectEndpoint + '/changeProject', changeProject).subscribe(response => {
      this.dialogRef.close();
    }, error => {
      console.log('error is', error);
    });
  }

}
